import { ColliWorkflowClient } from '@frontend/colli/api';
import { ColliTriggerName } from '@frontend/colli/types';
import { SelectInputV2 } from '@frontend/components/basic-forms';
import { ActionModal } from '@frontend/components/modal';
import { ToastUtil } from '@frontend/toast-utils';
import { FormattedMessage, useIntl } from 'react-intl';

import { ChangeColliStateModalProps, useChangeColliStateModal } from './change-colli-state-modal.controller';

export const ChangeColliStateModal = (props: ChangeColliStateModalProps) => {
    const intl = useIntl();
    const viewProps = useChangeColliStateModal(props);

    return (
        <ActionModal
            title={
                <FormattedMessage
                    id='platform.colli.modal.change-colli-state-modal.title'
                    description='Title of the action modal for changing a parcel status'
                    defaultMessage='Change parcel status'
                />
            }
            cancel={{
                onCancel: () => viewProps.closeTopModal(),
                label: (
                    <FormattedMessage
                        id='action-modal.cancel'
                        defaultMessage='No, cancel'
                    />
                )
            }}
            confirm={{
                onConfirm: async () => {
                    if (!viewProps.selectedTrigger) return;
                    await Promise.all(
                        props.collis.map(async (colli) => {
                            await ColliWorkflowClient.triggerColliState(colli.account_id, colli.transaction_id, colli.id, {
                                trigger: viewProps.selectedTrigger!
                            });
                        })
                    );
                    if (props.onSubmitCallback) {
                        props.onSubmitCallback();
                    }
                    ToastUtil.success(
                        intl.formatMessage({
                            id: 'platform.colli.modal.change-colli-state-modal.success',
                            description: 'Toast shown when a parcel status is changed successfully',
                            defaultMessage: 'Changed parcel status successfully.'
                        })
                    );
                    viewProps.closeTopModal();
                },
                disabled: viewProps.isLoading || !viewProps.selectedTrigger,
                label: (
                    <FormattedMessage
                        id='action-modal.confirm-change-status'
                        defaultMessage='Yes, change status'
                    />
                )
            }}>
            <div className='text-brand-muted justify-start self-stretch text-base font-medium'>
                <FormattedMessage
                    id='platform.colli.modal.change-colli-state-modal.confirmation'
                    description='Confirmation message shown before changing the status of selected parcels'
                    defaultMessage='Are you sure you want to change the status of all selected parcels? Based on your workflow settings, this action may trigger notifications to the senders and/or receivers.'
                />
            </div>
            <SelectInputV2
                hideLabel
                className='w-full'
                isLoading={viewProps.isLoading}
                onSelect={(v) => viewProps.setSelectedTrigger(v?.value as ColliTriggerName | undefined)}
                options={viewProps.options}
            />
        </ActionModal>
    );
};
